var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCicdpipelinesetup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14092_20355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12H28C29.1028 12 30 11.1025 30 10V4C30 2.8975 29.1028 2 28 2H22C20.8972 2 20 2.8975 20 4V6H11C8.2429 6 6 8.2432 6 11H4C2.8972 11 2 11.8975 2 13V19C2 20.1025 2.8972 21 4 21H6C6 23.7568 8.2429 26 11 26H20V28C20 29.1025 20.8972 30 22 30H28C29.1028 30 30 29.1025 30 28V22C30 20.8975 29.1028 20 28 20H22C20.8972 20 20 20.8975 20 22V24H11C9.3457 24 8 22.6543 8 21H10C11.1028 21 12 20.1025 12 19V13C12 11.8975 11.1028 11 10 11H8C8 9.3457 9.3457 8 11 8H20V10C20 11.1025 20.8972 12 22 12ZM22 22H28V28H22L21.9988 22H22ZM10 13V19H4L3.9988 13H10ZM22 4H28V10H22L21.9988 4H22Z",
    fill: "#0CB0B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14092_20355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCicdpipelinesetup);
export default __webpack_public_path__ + "static/media/Cicd pipeline setup.b5eb226664835167c8a161804f38ca50.svg";
export { ForwardRef as ReactComponent };